import React from 'react';
import Modal from 'pubweb-smokey/dist/components/Modal/Modal';
import ContactModalStyles from './ContactModal.styled';

const ContactModal = ({ children }) => {
  return <ContactModalStyles>{children}</ContactModalStyles>;
};

export default ContactModal;
